import type { TournamentsApi } from '@/v2/api/metadata/tournaments'
import type { ContentTab, DialogTabSaveContext } from '@/v2/framework/dialog/types'
import { tournamentConfigurationSaveRef } from './configuration/save-ref'

async function save(_ctx: DialogTabSaveContext): Promise<void> {
  if (!tournamentConfigurationSaveRef.value) return
  await tournamentConfigurationSaveRef.value()
}

export function createConfigurationTab(options: { tournamentsApi: TournamentsApi }): ContentTab {
  const { tournamentsApi } = options

  return {
    id: 'configuration',
    label: 'Configurations',
    save,
    children: [
      {
        type: 'component',
        component: () => import('./configuration/TournamentConfigurationFields.vue'),
        props: { tournamentsApi },
      },
    ],
  }
}
